import { render, staticRenderFns } from "./newsinfo.vue?vue&type=template&id=3bd37d08&scoped=true"
import script from "./newsinfo.vue?vue&type=script&lang=js"
export * from "./newsinfo.vue?vue&type=script&lang=js"
import style0 from "./newsinfo.vue?vue&type=style&index=0&id=3bd37d08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd37d08",
  null
  
)

export default component.exports